import axios, { AxiosRequestConfig, isAxiosError } from 'axios';
import {
  DO_CENTRAL_SERVICE_URL,
  DO_INTERVIEW_SERVICE_URL,
  DOLORES_SERVICE_URL,
  DO_AI_INTERVIEW_SERVICE_URL,
  DO_DHWANI_SERVICE_URL,
} from '../constants/AppConstants';

import { doSelectCookies } from '../constants/UtilConstants';
import { captureException } from './sentry';

function cookieParser() {
  // Get all cookies as a single string
  const cookies = document.cookie;

  // Create an object to store parsed cookies
  const cookieObject: any = {};

  try {
    // Split the cookie string by semicolons
    const cookieArray = cookies.split(';');

    // Iterate over the array and parse each cookie
    cookieArray.forEach((cookie) => {
      const [name, value] = cookie.trim().split('=');
      if (name && value) {
        cookieObject[name] = decodeURIComponent(value); // Decode the value to handle special characters
      }
    });
    return cookieObject;
  } catch (err) {
    console.error('failed to parse cookie');
    return {};
  }
}

const APIRequestWithCredentialANDCookie = axios.create({
  withCredentials: true,
  /**
   * Refer: https://docs.djangoproject.com/en/1.8/ref/csrf/#ajax
   * `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
   * `xsrfHeaderName` is the name of the http header that carries the xsrf token value
   */
  xsrfCookieName: doSelectCookies.XSRF_COOKIE_NAME,
  xsrfHeaderName: doSelectCookies.XSRF_HEADER_NAME,
});

const APIRequestWithCredential = axios.create({
  withCredentials: true,
});

const APIRequestWithOutCredential = axios.create({
  withCredentials: false,
});

APIRequestWithCredentialANDCookie.interceptors.request.use(
  (config) => {
    // Example usage: Get the CSRF token from the cookies
    const cookies = cookieParser();
    const csrfToken = cookies && cookies.doselectcsrf; // Replace 'csrftoken' with your actual cookie name
    if (csrfToken) {
      // eslint-disable-next-line no-param-reassign
      config.headers['X-CSRFToken'] = csrfToken; // Replace 'X-CSRFToken' with your server's expected header name
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendRequestToDoSelectCentralService = <ResponseType = any>(
  requestData: AxiosRequestConfig,
  expectedError?: number[]
) => {
  try {
    requestData.baseURL = DO_CENTRAL_SERVICE_URL;
    return APIRequestWithCredentialANDCookie<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      captureException(error);
    }
    return Promise.reject(error);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendRequestToDoloresService = <ResponseType = any>(
  requestData: AxiosRequestConfig,
  expectedError?: number[]
) => {
  try {
    requestData.baseURL = DOLORES_SERVICE_URL;
    return APIRequestWithCredentialANDCookie<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      captureException(error);
    }
    return Promise.reject(error);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendRequestToServerWithCredentials = <ResponseType = any>(
  requestData: AxiosRequestConfig,
  expectedError?: number[]
) => {
  try {
    requestData.baseURL = DO_INTERVIEW_SERVICE_URL;
    return APIRequestWithCredential<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      captureException(error);
    }
    return Promise.reject(error);
  }
};

export const sendRequestToInterviewServiceWithoutCredentials = <
  ResponseType = any
>(
  requestData: AxiosRequestConfig,
  expectedError?: number[]
) => {
  try {
    requestData.baseURL = DO_INTERVIEW_SERVICE_URL;
    return APIRequestWithOutCredential<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      captureException(error);
    }
    return Promise.reject(error);
  }
};

// // eslint-disable-next-line @typescript-eslint/no-explicit-any
// export const sendRequestToAiInterviewServiceWithCredentials = <ResponseType = any>(
//   requestData: AxiosRequestConfig,
//   expectedError?: number[]
// ) => {
//   try {
//     requestData.baseURL = DO_AI_INTERVIEW_SERVICE_URL;
//     return APIRequestWithCredential<ResponseType>(requestData);
//   } catch (error) {
//     if (
//       isAxiosError(error) &&
//       error.response?.status &&
//       !expectedError?.includes(error.response.status)
//     ) {
//       captureException(error);
//     }
//     return Promise.reject(error);
//   }
// };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendRequestToDhwanoServiceWithCredentials = <ResponseType = any>(
  requestData: AxiosRequestConfig,
  expectedError?: number[]
) => {
  try {
    requestData.baseURL = DO_DHWANI_SERVICE_URL;
    return APIRequestWithCredential<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      captureException(error);
    }
    return Promise.reject(error);
  }
};

export const sendRequestToDhwanoServiceWithoutCredentials = <
  ResponseType = any
>(
  requestData: AxiosRequestConfig,
  expectedError?: number[]
) => {
  try {
    requestData.baseURL = DO_DHWANI_SERVICE_URL;
    return APIRequestWithOutCredential<ResponseType>(requestData);
  } catch (error) {
    if (
      isAxiosError(error) &&
      error.response?.status &&
      !expectedError?.includes(error.response.status)
    ) {
      captureException(error);
    }
    return Promise.reject(error);
  }
};
